/**
 * Wo war der Besucher, als er sich anmelden musste?
 *
 * Der Weg über Google verlässt die Anwendung ganz — Zustand im Speicher
 * überlebt das nicht. Ohne Merker landete jeder nach der Anmeldung stur auf
 * dem Karten-Einstieg: Wer in einer Artenansicht stand und aufs Herz tippte,
 * fand sich danach in der Übersicht wieder (Alex 2026-08-12).
 *
 * Eigene Datei, weil `auth.tsx` Komponenten exportiert — eine zusätzliche
 * Funktion daneben nimmt dem Fast Refresh die Arbeitsgrundlage (eslint
 * `react-refresh/only-export-components`).
 */
const SCHLUESSEL = 'tschepp-login-rueckweg'

/** Höchstalter eines gemerkten Rückwegs: länger als jeder Anmeldevorgang,
 *  kurz genug, dass ein abgebrochener Anlauf nicht später noch wirkt. */
const TTL_MS = 15 * 60 * 1000

export function merkeLoginRueckweg(url: string): void {
  // localStorage, nicht sessionStorage: Manche Browser öffnen die Google-Seite
  // in einem neuen Kontext, dann ist die Sitzung leer.
  try { localStorage.setItem(SCHLUESSEL, JSON.stringify({ url, ts: Date.now() })) }
  catch { /* privater Modus — dann eben der Rückfall */ }
}

/** Einmalig: liest den gemerkten Rückweg UND löscht ihn. */
export function nimmLoginRueckweg(): string | null {
  try {
    const raw = localStorage.getItem(SCHLUESSEL)
    localStorage.removeItem(SCHLUESSEL)
    if (!raw) return null
    const { url, ts } = JSON.parse(raw) as { url?: string; ts?: number }
    if (!url || !ts || Date.now() - ts > TTL_MS) return null
    // Nur seiteninterne Ziele — ein absoluter Fremdlink wäre eine offene
    // Weiterleitung.
    return url.startsWith('/') && !url.startsWith('//') ? url : null
  } catch { return null }
}
